
    export default 
    {
    "banner_v2": {
        "title": "<span class={title}>Ottieni <span class={highlight}>$100</span> e più durante il Periodo dei Premi di DSers</span>",
        "desc": "Il Periodo dei Premi di DSers avrà luogo dal 15 di ottobre al 15 di gennaio. <br />Gli inviti saranno inviati a venditori casuali a settembre. <br />Si prega di controllare l'email utilizzata per creare l'account DSers.",
        "learn_more": "Scopri di più"
    }
}